import treeLogo from "../assets/images/tree-logo.svg";
import t from "../locales";

const Footer = () => {
  return (
    <footer className="footer">
      <img className="footer__logo" src={treeLogo} alt={t("footer.label")} />
    </footer>
  );
};

export default Footer;
